import script from "./previousClasses.vue?vue&type=script&setup=true&lang=js"
export * from "./previousClasses.vue?vue&type=script&setup=true&lang=js"

import "./previousClasses.vue?vue&type=style&index=0&id=408870ea&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-408870ea"]])

export default __exports__